import {Palette} from '@material-ui/core/styles/createPalette';
import {darken, lighten} from '@material-ui/core/styles';

import {common} from './common';

const dodgerBlue = '#2486FB';
const success = '#7cb933';
const error = '#f44336';
// const primary = '#FF5612';
// const primary = '#151930';
const primary = '#2979FF';
const secondary = '#EC6225';
const icon = '#B7C0C8';

function paletteColor(color: string, contrastText = '#fff') {
  return {
    dark: darken(color, 0.2),
    main: color,
    light: lighten(color, 0.2),
    contrastText,
  };
}

/** This is all core colors of application LIGHT theme */
const palette: Partial<Palette> = {
  background: {
    paper: '#ffffff',
    default: '#E9EBED',
  },
  divider: '#DDDDDD',
  primary: paletteColor(primary),
  secondary: paletteColor(secondary),
  success: paletteColor(success),
  error: paletteColor(error),
  icon: {
    primary,
    grey: icon,
    darkGrey: darken(icon, 0.2),
  },
  link: {
    small: dodgerBlue,
    large: lighten(dodgerBlue, 0.2),
  },
};

export const lightTheme = common(palette);
